import { useState, useRef, useEffect } from 'react';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Image, Text } from '@weareconceptstudio/core';

//* Styles
import AboutHomeStyle from './style';

//* Components
import Button from '@/components/Button';
import TitleAnim from '@/modules/_animation/Title';

//* Helpers
import { config } from '@/helpers';

gsap.registerPlugin(ScrollTrigger);

const AboutHome = ({ description, image, title }) => {
	//! State
	const [imageLoad, setImageLoad] = useState(false);

	//! Ref
	const innerRef = useRef();
	const triggerRef = useRef();
	const buttonRef = useRef();
	const descriptionRef = useRef();
	const imageRef = useRef();

	useEffect(() => {
		if (imageLoad && innerRef.current) {
			triggerRef.current = ScrollTrigger.create({
				start: 'top-=30% bottom',
				end: 'top top',
				trigger: imageRef.current,
				// markers: true,
				onEnter: () => {
					if (imageRef.current && descriptionRef.current && buttonRef.current) {
						gsap.fromTo(imageRef.current, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power2.in' });
						gsap.fromTo(
							imageRef.current,
							{ y: '30%', rotate: -15 },
							{
								rotate: 0,
								duration: 1,
								ease: 'power2.out',
								y: 0,
								delay: 0.12,
							}
						);
						gsap.fromTo(descriptionRef.current, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power2.in', delay: 0.4 });
						gsap.fromTo(buttonRef.current, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 0.6, ease: 'power2.inOut', delay: 0.5 });
					}
				},
				onLeaveBack: () => {
					if (imageRef.current && descriptionRef.current && buttonRef.current) {
						gsap.killTweensOf([imageRef.current, buttonRef.current, descriptionRef.current]);

						gsap.set(imageRef.current, { opacity: 0, y: '30%', rotate: -15 });
						gsap.set(buttonRef.current, { scale: 0, opacity: 0 });
						gsap.set(descriptionRef.current, { opacity: 0 });
					}
				},
			});
		}
		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	});

	return (
		<AboutHomeStyle ref={innerRef}>
			<div className='inner-wrapper'>
				<div
					ref={imageRef}
					className='image-outside-wrap opacity-zero'
				>
					<Image
						onLoad={setImageLoad}
						src={image.src}
						alt={image.alt}
					/>
				</div>

				<div className='info-wrap'>
					<TitleAnim
						textCenter={false}
						load={imageLoad}
						animRefTrigger={innerRef}
					>
						<Text
							tag={'span'}
							className='font-larken-light h4 white-1000 title'
						>
							{title}
						</Text>
					</TitleAnim>
					<div
						ref={descriptionRef}
						className='opacity-zero'
					>
						<Text className='font-fss-light p1 white-1000 description'>{description}</Text>
					</div>
					<div
						ref={buttonRef}
						className='wrap-button opacity-zero'
					>
						<Button
							url={config.routes.aboutUs.path}
							btnType={'yellow-type'}
							text={'aboutUs'}
						/>
					</div>
				</div>
			</div>
		</AboutHomeStyle>
	);
};

export default AboutHome;
